import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";

export const PSV_REVIEW_POLL_INTERVAL_MS = 30_000;
const COUNT_PAGE_SIZE = 1;
const FIRST_PAGE_OFFSET = 0;

/** The business unit's open item totals. The queue's totals use the same
 * access rules as its rows, so request one row while counting. */
export function usePsvReviewCount(organizationBusinessUnitId: string) {
  const trpc = useTRPC();
  return useQuery(
    trpc.psv.review.listQueue.queryOptions(
      {
        organizationBusinessUnitId,
        limit: COUNT_PAGE_SIZE,
        offset: FIRST_PAGE_OFFSET,
      },
      {
        select: (page) => ({
          totalItems: page.totalItems,
          totalProviders: page.totalProviders,
        }),
        refetchInterval: PSV_REVIEW_POLL_INTERVAL_MS,
      },
    ),
  );
}
